
import { NdPrijemkaPolozky } from './polozky';

export { DMS_MODULE, MODULE_API } from '../constants';
export const NAME = 'NdPrijemka';
export const NAMEPolozky = 'NdPrijemkaPolozky';
export const CRUMB_LABEL_KEY = 'edtNDPrijemka';
export const PR_ORDER = "PROrders";

export const DOKLADY = <const>'Doklady';
export const EDL = 'Edl';

export enum NDPRIJEMKA_STATUS {
	OTEVRENA = 0,
	UZAV_KE_KOREKCI = 1,
	UZAVRENA = 2,
	VYRAZENA = 3,
	ERROR = 99,
}
export enum NDPRIJEMKA_PZN {
	PRIJEM_MANUAL = 0,
	PRIJEM_RYO = 1,
	PRIJEM_MO = 2,
	PRIJEM_PREVOD = 3,
	PRIJEM_SO = 4,
}

export const DEPENDENT_TABLES = <const>[
	NdPrijemkaPolozky.name,
	DOKLADY,
	PR_ORDER 
];

export const EDL_NDPRIJEM_PZN = <const>[
	NDPRIJEMKA_PZN.PRIJEM_SO,
	NDPRIJEMKA_PZN.PRIJEM_MO,
	NDPRIJEMKA_PZN.PRIJEM_RYO,
];
export enum HideColumns {
	SUPPLIER_ID = 'DODAVATEL_ID',
	PART_NO = 'ND',
	STATUS_ID = 'STATUS_ID',
	PR_DOC_NO = 'PR_DOC_NO',
	IS_DEALER = 'IS_DEALER',
	WAREHOUSE_ID = 'WAREHOUSE_ID',
	ORDER_NO = 'ORDER_NO',
	BILL_TO_WAREHOUSE_ID = 'BILL_TO_WAREHOUSE_ID',
}
export type DependentTableNames = typeof DEPENDENT_TABLES[number];

export const ND_NR = 'ND_NR';
export const GRID_COLUMNS = {
	ND_NR,
};
